import { z } from 'zod';
import { SanityReferenceSchema, SanityDocumentSchema, SanityDocumentLikeSchema } from '../sanity';
import { ComponentType } from '$lib/sanity/types';

export const ModalSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.Modal),
  heading: z.string().nullable().optional(),
  variant: z.union([z.literal('topLeft'), z.literal('bottomCenter')]),
  altText: z.string().optional().nullable(),
  layout: z.object({
    gridItems: z
      .array(
        z.object({
          componentType: z
            .union([
              z.literal('dynamic'),
              z.literal('divider'),
              z.literal('portableText'),
              z.literal('modalText')
            ])
            .optional()
            .nullable(),
          component: z
            .union([SanityReferenceSchema, SanityDocumentLikeSchema])
            .nullable()
            .optional(),
          placements: z.array(
            z.object({
              grid: z.string(),
              columnSpan: z.number(),
              columnStart: z.number(),
              rowSpan: z.number(),
              rowStart: z.number()
            })
          ),
          id: z.string()
        })
      )
      .nullable()
      .optional()
  })
});

export type Modal = z.infer<typeof ModalSchema>;
